import React, { useState } from "react";
import FormBuilder from "../form_components/FormBuilder";
import Input from "../form_components/Input";
import { useAppDispatch } from "../../hooks";
import { fetchProjects } from "../../features/Project/ProjectSlice";
import SearchSelect from "components/form_components/SearchSelect";


export default function NewProject() {
    const dispatch = useAppDispatch();
    const onSubmit = ()=>{
        dispatch(fetchProjects());
    }
    type Port = { short: string; name: string };
    
    
    return (
        <>
            <FormBuilder title='Create project' post={'/projects'} onSubmit={onSubmit} >
                <Input width='full' label="Project name" type='text' placeholder='Project name' extraClasses='border block rounded px-2' required={true} value='' onChange={(name, value) => { }} name='name' />
                <Input width='full' label="Chief scientist" type='text' placeholder='Chief scientist' extraClasses='border block rounded px-2' required={true} value='' onChange={(name, value) => { }} name='chief_scientist' />
                <Input width='full' label="Start date" type='date' placeholder='Start date' extraClasses='border block rounded px-2' required={true} value='' onChange={(name, value) => { }} name='start_date' />
                <Input width='full' label="End date" type='date' placeholder='End date' extraClasses='border block rounded px-2' required={true} value='' onChange={(name, value) => { }} name='end_date' />
                <Input width='full' label="Vessel" type='text' placeholder='Vessel' extraClasses='border block rounded px-2' required={true} value='' onChange={(name, value) => { }} name='vessel' />
                <SearchSelect<Port>
                    width="full"
                    label="Departure Harbour"
                    name="departure_port" 
                    dataUrl="/data/ports.json"
                    getOptionLabel={(o) => o.name} 
                    getOptionValue={(o) => o.short}  
                    extraClasses="border block rounded px-2"
                    required
                />
                
                <SearchSelect<Port>
                    width="full"
                    label="Arrival Harbour"
                    name="arrival_port"  
                    dataUrl="/data/ports.json"
                    getOptionLabel={(o) => o.name} 
                    getOptionValue={(o) => o.short} 
                    extraClasses="border block rounded px-2"
                    required
                />
            </FormBuilder>
        </>
    );
}